import styled from 'styled-components';
import { media } from './StyledCalendarBase';

// Estilos específicos para componentes móviles

// Estilos para MobileWeekView
export const MobileWeekContainer = styled.div`
    padding: 16px;
`;

export const MobileDayCard = styled.div`
    margin-bottom: 20px;
    background-color: #FFFFFF;
    border-radius: 12px;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
`;

export const MobileDayHeader = styled.div`
    padding: 16px;
    background-color: ${props => props.isToday ? 'hsl(24, 85%, 60%)' : 'hsl(210, 40%, 98%)'};
    border-bottom: 1px solid hsl(220, 13%, 91%);
`;

export const MobileDayHeaderContent = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const MobileDayTitle = styled.h3`
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: ${props => props.isToday ? '#FFFFFF' : 'hsl(0, 0%, 20%)'};
`;

export const MobileDayBadge = styled.div`
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: ${props => props.isToday ? 'rgba(255, 255, 255, 0.2)' : 'hsl(24, 85%, 60%)'};
    color: ${props => props.isToday ? '#FFFFFF' : '#FFFFFF'};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
`;

export const MobileDayContent = styled.div`
    padding: 16px;
`;

export const MobileAppointmentsTitle = styled.h4`
    margin: 0 0 12px 0;
    font-size: 14px;
    font-weight: 600;
    color: hsl(0, 0%, 20%);
`;

export const MobileAppointmentsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const MobileAppointmentCard = styled.div`
    padding: 12px;
    background-color: ${props => props.backgroundColor};
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const MobileAppointmentCardWithOpacity = styled(MobileAppointmentCard)`
    opacity: ${props => props.opacity};
`;

export const MobileAppointmentInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1;
    min-width: 0;
`;

export const MobileAppointmentName = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;
    font-weight: 600;
    color: #FFFFFF;
    max-width: 100%;
`;

export const MobileAppointmentTime = styled.div`
    font-size: 11px;
    opacity: 0.9;
    font-weight: 500;
    color: #FFFFFF;
    margin-top: 2px;
`;

export const MobileAppointmentActions = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const MobileNoAppointments = styled.div`
    text-align: center;
    padding: 20px;
    color: hsl(0, 0%, 50%);
    font-size: 14px;
`;

export const MobileAddAppointmentButton = styled.button`
    width: 100%;
    padding: 12px;
    background-color: hsl(24, 85%, 60%);
    color: #FFFFFF;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    margin-top: 16px;
    
    &:hover {
        opacity: 0.9;
    }
`;

// Estilos para MobileMonthView
export const MobileMonthContainer = styled.div`
    padding: 16px;
`;

export const MobileMonthHeader = styled.div`
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 4px;
    margin-bottom: 12px;
`;

export const MobileMonthHeaderCell = styled.div`
    text-align: center;
    font-size: 12px;
    font-weight: 600;
    color: hsl(0, 0%, 30%);
    padding: 8px 4px;
`;

export const MobileWeekRow = styled.div`
    margin-bottom: 12px;
`;

export const MobileWeekGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 6px;
`;

export const MobileEmptyDay = styled.div`
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const MobileMonthDay = styled.div`
    height: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    background-color: #FFFFFF;
    border-radius: 8px;
    border: 1px solid hsl(220, 13%, 91%);
`;

export const MobileMonthDayWithToday = styled(MobileMonthDay)`
    background-color: ${props => props.isToday ? 'hsl(24, 85%, 60%)' : '#FFFFFF'};
    cursor: pointer;
    transition: all 0.2s ease;
`;

export const MobileMonthDayNumber = styled.div`
    color: ${props => props.isToday ? '#FFFFFF' : 'hsl(0, 0%, 25%)'};
    font-size: 14px;
    font-weight: 600;
`;

export const MobileMonthDayNumberWithAppointments = styled.div`
    color: ${props => props.isToday ? '#FFFFFF' : 'hsl(0, 0%, 25%)'};
    font-size: 14px;
    font-weight: 600;
`;

export const MobileAppointmentDot = styled.div`
    position: absolute;
    bottom: 4px;
    left: 50%;
    transform: translateX(-50%);
    width: 20px;
    height: 20px;
    background-color: #23AAAF;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const MobileAppointmentDotWithCount = styled.div`
    position: absolute;
    bottom: 4px;
    left: 50%;
    transform: translateX(-50%);
    width: 20px;
    height: 20px;
    background-color: #23AAAF;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const MobileAppointmentCount = styled.div`
    font-size: 9px;
    font-weight: 700;
    color: #23AAAF;
`;

export const MobileAppointmentCountText = styled.div`
    font-size: 9px;
    font-weight: 700;
    color: #23AAAF;
`;

export const MobileMonthDayWithAppointments = styled.div`
    height: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    background-color: #FFFFFF;
    border-radius: 8px;
    border: 1px solid hsl(220, 13%, 91%);
`;

// Estilos para dropdowns y status
export const StatusDropdownContainer = styled.div`
    position: relative;
    display: inline-block;
    z-index: 1;
    
    &.dropdown-open {
        z-index: 99999999 !important;
    }
`;

export const StatusDropdownContainerDynamic = styled(StatusDropdownContainer)`
    z-index: ${props => props.isOpen ? '99999999' : '1'};
`;

export const StatusDropdownButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    transition: background-color 0.2s ease;
    
    &:hover {
        background-color: hsl(0, 0%, 95%);
    }
    
    &:focus {
        outline: 2px solid hsl(24, 85%, 60%);
        outline-offset: 2px;
    }
`;

export const StatusDropdownButtonDynamic = styled(StatusDropdownButton)`
    z-index: ${props => props.isOpen ? '99999999' : 'auto'};
`;

export const StatusDropdownMenu = styled.div`
    position: absolute;
    top: 100%;
    right: 0;
    background: white;
    border: 1px solid hsl(220, 13%, 91%);
    border-radius: 8px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 99999999 !important;
    width: 140px;
    min-width: 140px;
    max-width: 140px;
    padding: 8px 0;
    margin-top: 4px;
`;

export const StatusDropdownMenuDynamic = styled(StatusDropdownMenu)`
    position: fixed;
    top: ${props => props.top}px;
    left: ${props => props.left}px;
    z-index: 99999999;
    min-width: 140px;
    max-width: 140px;
    width: 140px;
    transform-origin: ${props => props.direction === 'up' ? 'center bottom' : 'center top'};
`;

export const DropdownOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99999998 !important;
    background: transparent;
    pointer-events: auto;
`;

export const StatusDropdownItem = styled.button`
    width: 100%;
    background: none;
    border: none;
    padding: 8px 16px;
    text-align: left;
    cursor: pointer;
    font-size: 14px;
    color: hsl(0, 0%, 25%);
    transition: background-color 0.2s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    
    &:hover {
        background-color: hsl(0, 0%, 95%);
    }
    
    &:focus {
        outline: none;
        background-color: hsl(0, 0%, 95%);
    }
    
    ${media.mobile} {
        padding: 12px 16px;
        font-size: 16px;
    }
`;

// Iconos específicos
export const StatusIcon = styled.img`
    width: ${props => props.isSmall ? '12px' : '16px'};
    height: ${props => props.isSmall ? '12px' : '16px'};
`;

export const StatusIconSmall = styled.img`
    width: 12px;
    height: 12px;
`;

export const StatusIconRegular = styled.img`
    width: 16px;
    height: 16px;
`;

export const NavigationIcon = styled.img`
    width: 18px;
    height: 18px;
`;

export const CommonIcon = styled.img`
    width: 20px;
    height: 20px;
`;
